import { render } from "./userTeacher.vue?vue&type=template&id=7625d21b&scoped=true"
import script from "./userTeacher.vue?vue&type=script&lang=js"
export * from "./userTeacher.vue?vue&type=script&lang=js"

import "./userTeacher.vue?vue&type=style&index=0&id=7625d21b&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7625d21b"]])

export default __exports__